import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=1108f779&scoped=true&"
import script from "./NavigationSidebar.vue?vue&type=script&lang=ts&"
export * from "./NavigationSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSidebar.vue?vue&type=style&index=0&id=1108f779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108f779",
  null
  
)

export default component.exports